<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { type MarketColors } from '@/types';

interface Props {
  value?: number;
  color?: MarketColors[number] | 'primary';
}

withDefaults(defineProps<Props>(), {
  value: 0,
  color: 'primary',
});

const { t } = useI18n();
</script>

<template>
  <div
    :style="`--filler-50: var(--${color})`"
    class="grid w-full grid-cols-[1fr_auto] gap-2 text-2xl text-filler-50"
  >
    <span>{{ t('progress-bar.loading') }}</span>
    <span>{{ value }}%</span>
    <progress
      class="col-span-2 h-1.5 w-full [&::-moz-progress-bar]:bg-filler-50 [&::-webkit-progress-bar]:rounded-lg [&::-webkit-progress-bar]:bg-filler-50/20 [&::-webkit-progress-value]:rounded-lg [&::-webkit-progress-value]:bg-filler-50"
      max="100"
      :value="value"
    />
  </div>
</template>
